module.exports = __webpack_public_path__ + "img/max5.edaf5904.jpg";